import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="28sl4n0mhvsgk">
      <MetaPixel data-id="element-1" data-mp="23vkv2fqfs7kp" />
      <UtmifyScript data-id="element-2" data-mp="23w4e5zrtp20b" />
      <CountdownBar data-id="element-3" data-mp="23ujl6el5pr4k" />
      <main data-id="element-4" data-mp="23t8heerpojdg">
        <Hero data-id="element-5" data-mp="23ti7018ugoim" />
        <StatsBar data-id="element-6" data-mp="3ik7g4ghnibqn" />
        <Difference data-id="element-7" data-mp="3ikr0e3urxc7u" />
        <Recognize data-id="element-8" data-mp="3ij65ue8glt9z" />
        <WhatsInside data-id="element-9" data-mp="3ijpet5g4t7bv" />
        <LookInside data-id="element-10" data-mp="3mljat0fdtn5p" />
        <InstantAccess data-id="element-11" data-mp="3ml12v6jcxkhy" />
        <Bonuses data-id="element-12" data-mp="3mk8710lxsfel" />
        <Offer data-id="element-13" data-mp="3mjq1tehaqquj" />
        <Guarantee data-id="element-14" data-mp="3mjgclt42snpw" />
        <Testimonials data-id="element-15" data-mp="3rcj5s04xxv5k" />
        <Faq data-id="element-16" data-mp="3rbznujfaj6rj" />
      </main>
      <Footer data-id="element-17" data-mp="3rcsw5otwe4bs" />
    </div>;
}